/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
*/

const chMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  'user.login-title': '登录',
  'user.register': '注册',
  'user.forgot-password': '忘记密码',
  'user.email': '电子邮件',
  'user.newpassword': '新密码',
  'user.currentpassword': '当前密码',
  'user.newpasswordagain': '再次输入新密码',
  'user.password': '密码',
  'user.forgot-password-question': '忘记密码？',
  'user.fullname': '全名',
  'user.firstname': '名字',
  'user.lastname': '姓氏',
  'user.login-button': '登录',
  'user.register-button': '注册',
  'user.reset-password-button': '重置',
  'user.buy': '购买',
  'user.username': '用户名',

  /* 03.Menu */
  'menu.app': '首页',

  'menu.default': '默认',
  'menu.analytics': '分析',
  'menu.ecommerce': '电子商务',
  'menu.content': '内容',
  'menu.pages': '页面',
  'menu.data-list': '数据列表',
  'menu.thumb-list': '缩略图列表',
  'menu.image-list': '图片列表',
  'menu.details': '详情',
  'menu.search': '搜索',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.forgot-password': '忘记密码',
  'menu.error': '错误',
  'menu.applications': '应用',
  'menu.todo': '待办事项',
  'menu.survey': '调查',
  'menu.chat': '聊天',
  'menu.ui': '用户界面',
  'menu.edit': '编辑',
  'menu.alerts': '警报',
  'menu.badges': '徽章',
  'menu.buttons': '按钮',
  'menu.cards': '卡片',
  'menu.carousel': '轮播',
  'menu.charts': '图表',
  'menu.collapse': '折叠',
  'menu.dropdowns': '下拉菜单',
  'menu.editors': '编辑器',
  'menu.form-layouts': '表单布局',
  'menu.form-components': '表单组件',
  'menu.form-validations': '表单验证',
  'menu.icons': '图标',
  'menu.input-groups': '输入组',
  'menu.jumbotron': '大幅横幅',
  'menu.modal': '模态框',
  'menu.navigation': '导航',
  'menu.popover-tooltip': '弹出框 & 提示框',
  'menu.sortable': '可排序',
  'menu.tables': '表格',
  'menu.menu': '菜单',
  'menu.subhidden': '子隐藏',
  'menu.hidden': '隐藏',
  'menu.visible': '可见',
  'menu.maps': '地图',
  'menu.landingpage': '登录页',
  'menu.multipage-home': '多页首页',
  'menu.singlepage-home': '单页首页',
  'menu.about': '关于',
  'menu.auth-login': '认证登录',
  'menu.auth-register': '认证注册',
  'menu.blog': '博客',
  'menu.blog-detail': '博客详情',
  'menu.careers': '招聘',
  'menu.confirmation': '确认',
  'menu.contact': '联系',
  'menu.docs': '文档',
  'menu.features': '功能',
  'menu.prices': '价格',
  'menu.videos': '视频',
  'menu.mailing': '邮件',
  'menu.invoice': '发票',
  'menu.blank-page': '敬请期待...',
  'menu.types': '菜单类型',
  'menu.levels': '菜单级别',
  'menu.third-level-1': '第三级 1',
  'menu.third-level-2': '第三级 2',
  'menu.third-level-3': '第三级 3',

  /* 04.Dashboards */
  'dashboards.update': '更新',
  'dashboards.save': '保存',
  'dashboards.saveSchedule': '保存日程',
  'dashboards.pending-orders': '待处理订单',
  'dashboards.completed-orders': '已完成订单',
  'dashboards.refund-requests': '退款请求',
  'dashboards.new-comments': '新评论',
  'dashboards.sales': '销售额',
  'dashboards.orders': '订单',
  'dashboards.refunds': '退款',
  'dashboards.recent-orders': '最近订单',
  'dashboards.product-categories': '产品分类',
  'dashboards.cakes': '蛋糕',
  'dashboards.tickets': '门票',
  'dashboards.calendar': '日历',
  'dashboards.best-sellers': '畅销品',
  'dashboards.per-session': '每次会话',
  'dashboards.profile-status': '个人资料状态',
  'dashboards.payment-status': '付款状态',
  'dashboards.work-progress': '工作进度',
  'dashboards.tasks-completed': '已完成任务',
  'dashboards.payments-done': '已付款',
  'dashboards.order-stock': '订单 - 库存',
  'dashboards.categories': '类别',
  'dashboards.quick-post': '快速发布',
  'dashboards.title': '标题',
  'dashboards.content': '内容',
  'dashboards.ticket-count': '票数',
  'dashboards.commonticketsubmission': '常见票务提交',
  'dashboards.category': '类别',
  'dashboards.save-and-publish': '保存并发布',
  'dashboards.top-viewed-posts': '浏览量最高的帖子',
  'dashboards.posts': '帖子',
  'dashboards.pending-for-publish': '待发布',
  'dashboards.users': '用户',
  'dashboards.on-approval-process': '审批中',
  'dashboards.alerts': '警报',
  'dashboards.waiting-for-notice': '等待通知',
  'dashboards.files': '文件',
  'dashboards.pending-for-print': '待打印',
  'dashboards.logs': '日志',
  'dashboards.connect': '连接',
  'dashboards.gogo': '加油',
  'dashboards.magic-is-in-the-details': '魔力在于细节',
  'dashboards.yes-it-is-indeed': '是的，确实如此！',
  'dashboards.advanced-search': '高级搜索',
  'dashboards.toppings': '配料',
  'dashboards.type': '类型',
  'dashboards.keyword': '关键词',
  'dashboards.search': '搜索',
  'dashboards.top-rated-items': '最高评分项目',

  'dashboards.country': '国家',
  'dashboards.webVisitors': '网站访客',
  'dashboards.avatarClicks': '头像点击',
  'dashboards.wordCloud': '词云',
  'dashboards.topic': '主题',
  'dashboards.name': '姓名',
  'dashboards.button': '按钮',
  'dashboards.visits': '访问',
  'dashboards.checkAvailability': '查看可用性或价格',
  'dashboards.details': '详细信息',
  'dashboards.roomsAvailability': '客房和可用性',
  'dashboards.startChat': '开始聊天',
  'dashboards.restaurantsBars': '餐厅和酒吧',
  'dashboards.groupBooking': '团体预订',
  'dashboards.promotions': '促销',
  'dashboards.weedingevents': '婚礼与活动',
  'dashboards.lostsomething': '丢失物品',
  'dashboards.producttext': '产品文字',
  'dashboards.bookingroomnew': '预订新房间',
  'dashboards.email': '电子邮件',
  'dashboards.phone': '电话',
  'dashboards.zipcode': '邮政编码',
  'dashboards.marketingconsent': '营销同意',
  'dashboards.additionalinfo': '附加信息',
  'dashboards.viewallcontacts': '查看所有联系人',
  'dashboards.current': '当前',
  'dashboards.last7days': '过去7天',
  'dashboards.last30days': '过去30天',
  'dashboards.thisweek': '本周',
  'dashboards.thismonth': '本月',
  'dashboards.previousmonth': '上个月',
  'dashboards.yeartodate': '年初至今',
  'dashboards.lastyear': '去年',
  'dashboards.all': '全部',
  'dashboards.standardOccupancy': '标准入住人数',
  'dashboards.max-occupancy': '最大容纳人数',
  'dashboards.numberOfThisType': '此类型数量',
  'dashboards.displayOrder': '显示顺序',
  'dashboards.provider': '提供商',
  'dashboards.edit': '编辑',
  'dashboards.delete': '删除',
  'dashboards.addImages': '添加图片',
  'dashboards.location_ip': '位置為根据 IP 地址估算',
  'dashboards.near': '附近',
  'dashboards.referral': '用户通过此网站转到您的页面',
  'dashboards.calling_party': '主叫方用户',
  'dashboards.called_party': '被叫方用户',
  'dashboards.lastdial': '最近拨号',
  'dashboards.imagelink': '图片链接',
  'dashboards.browsegallery': '浏览画廊',
  'dashboards.changelog': '更改日志',
  'dashboards.externalresources': '外部资源',
  'dashboards.webpage': '网页',
  'dashboards.web-pages': '网页',
  'dashboards.published': '已发布',
  'dashboards.adddocument': '添加文档',
  'dashboards.ready-to-publish': '准备发布',
  'dashboards.draft': '草稿',
  'dashboards.order-by': '排序依据',
  'dashboards.add-faq': '添加常见问题',
  'dashboards.collections': '合集',
  'dashboards.items': '物品',
  'dashboards.rooms-availability': '房间和可用性',
  'dashboards.events-wedding-venues': '活动和婚礼场地',
  'dashboards.long-stay-enquiry': '长期住宿咨询',
  'dashboards.reservation-confirmation-request': '预订确认请求',
  'dashboards.modify-cancel-booking': '修改或取消预订',
  'dashboards.left-something-behind': '遗留物品',
  'dashboards.invoice-copy': '发票 / 收据副本',
  'dashboards.sync': '同步',
  'dashboards.syncNow': '立即同步',
  'dashboards.add-web-page': '添加网页',
  'dashboards.sprint-title':
    '认识 Sprint，我们的突破性自动化，可在10倍更短的时间内训练 AI 模型。',
  'dashboards.sprint-description':
    'Sprint 与您协作——释放创造力，提升生产力，显著减少训练数字助理所需的时间。',
  'dashboards.sprint-feature':
    'Sprint 功能旨在同步来自外部来源的知识，对初始设置和持续数据更新都非常有价值。在活动系统上执行时，Sprint 会根据您配置的外部来源修改知识中心，直接影响 AI 生成的行为和响应。若需 Sprint 设置协助，请联系支持团队。',
  'dashboards.change-password': '更改密码',
  'dashboards.sign-out': '登出',
  'dashboards.privacy-policy': '隐私政策',
  'dashboards.help-center': '帮助中心',
  'dashboards.switch-account': '切换账户',
  'dashboards.business-settings': '业务设置',
  'dashboards.notifications-allowed': '允许通知',
  'dashboards.dark-theme': '深色主题',
  'dashboards.online': '在线',
  'dashboards.offline': '离线',
  'dashboards.invoice-&-payments': '发票和付款',
  'dashboards.upgrade-plan': '升级计划',
  'dashboards.add-room': '添加房间',
  'dashboards.room-type': '房间类型',
  'dashboards.room-name': '房间名称',
  'dashboards.how-many-guests': '每个房间的总客人数',
  'dashboards.numberofBeds': '床位数',
  'dashboards.number-of-rooms-this-type': '房间数量（此类型）',
  'dashboards.number-of-bedrooms': '卧室数量',
  'dashboards.number-of-livingrooms': '客厅数量',
  'dashboards.minimum-adults': '最少成人',
  'dashboards.maximum-adults': '最多成人',
  'dashboards.maximum-children': '最多儿童',
  'dashboards.maximum-infants': '最多婴儿',
  'dashboards.extra-beds-allowed': '允许额外加床',
  'dashboards.booking-engine-code': '预订系统代码',
  'dashboards.room-size': '房间大小',
  'dashboards.balcony-area': '阳台面积',
  'dashboards.unit': '单位',
  'dashboard.whatsapp_message': '在此输入您的消息...',
  'dashboard.whatsapp_reply_window':
    '自客户最后一次发送消息起，您有 24 小时的时间在 WhatsApp Business 上回复客户消息。如果您在这 24 小时的客户服务窗口内回复，可以发送任何类型的消息。24 小时窗口关闭后，您只能使用预先批准的消息模板发送消息，并在客户回复时重新启动 24 小时窗口。',
  'dashboards.square-meters': '平方米',
  'dashboard.pick_quick_reply': '选择快速回复或输入您的消息',
  'dashboard.hang_in_there': '请稍候，我们正在尝试为您连接！',
  'dashboard.outbound_msg': '发送外发消息的时间',
  'dashboard.message_sent': '您的消息已成功发送！',
  'dashboard.failed_msg': '消息发送失败',
  'dashboard.new_chat_message': '新的聊天消息',
  'dashboard.user_msg':
    '在过去 24 小时内有用户消息，您可以回复任何消息。您仍然要发送此模板消息，还是回复其他消息？',
  'dashboard.us_number':
    '由于 Meta 于 2025 年 4 月 1 日暂停向美国号码发送所有营销消息，WhatsApp Business 消息不会发送到美国号码。',

  'dashboard.error_msg': '请正确填写所有占位符。',

  'web-widget.title': '网站聊天机器人网页小部件菜单',

  /*Home page*/
  'dashboards.quickstartwithai': 'AI 快速开始',
  'dashboards.fastestpathtoautomation':
    '您正处于使用 AI 工具进行自动化的最快路径',
  'dashboards.insightsthatempower': '赋能洞察',
  'dashboards.trainchatbot': '训练聊天机器人',
  'dashboards.automatewithforms': '通过表单自动化',
  'dashboards.inroomdigitalcompendium': '房内数字指南',
  'dashboards.support': '支持',
  'dashboards.helpcenter': '帮助中心',
  'dashboards.searchfaqintegrations': '查找有关常见 FAQ、集成等的文章。',
  'dashboards.asklivechat': '通过实时聊天向我们的团队提问',
  'dashboards.inroomqrcode': '房内 QR 码查看物业和位置的信息',
  'dashboards.customizewebwidget':
    '自定义并将 Web Widget 添加到您的网站，集成 AI 聊天机器人',
  'dashboards.createcustomforms': '创建自定义表单，并在客人提交表单时收到通知',
  'dashboards.trainchatbotproperty':
    '使用关于物业的信息（如入住时间、活动等）训练 Chatbot',
  'dashboards.chatbotinsights':
    '查看您的 Chatbot 如何与客人互动，并获取有关网站访客、常见问题等的统计洞察',

  /* Email Stats */
  'dashboards.thread-summary-title': '线程摘要',
  'dashboards.thread-summary-subtitle': '由 AI 生成的电子邮件摘要',
  'dashboards.ai-replies-title': 'AI 回复',
  'dashboards.ai-replies-subtitle': '由 AI 生成的回复',
  'dashboards.total-thread-summary-title': '生成的线程摘要总数',
  'dashboards.total-ai-replies-title': '生成的 AI 回复总数',
  'dashboards.total-draft-copied': '用户复制的草稿',
  'dashboards.urgency': '紧急程度',
  'dashboards.sentiment': '情绪',
  'dashboards.common-email-reasons': '常见电子邮件原因',
  'dashboards.topics-in-emails': '电子邮件主题',
  'dashboards.email-assistant-usage': 'AI 邮件助手使用情况',
  'dashboards.usage-by-email-address': '按电子邮件地址使用情况',

  /* 05.Pages */
  'pages.title.dashboards.analytics': '分析',
  'pages.title.ari': '可用性和价格',
  'pages.title.conversations': '对话',
  'pages.title.bookings': '预订和预约',
  'pages.title.tickets': '线索和工单',
  'pages.title.propinfo': '回复',
  'pages.title.discounts': '折扣和促销',
  'pages.title.finance': '财务',
  'pages.title.integration': '集成',
  'pages.title.admin': '管理',
  'pages.add-new': '新增',
  'pages.add-new-modal-title': '添加新项目',
  'pages.display-options': '显示选项',
  'pages.orderby': '排序方式：',
  'pages.product-name': '产品名称',
  'pages.category': '类别',
  'pages.description': '描述',
  'pages.status': '状态',
  'pages.cancel': '取消',
  'pages.submit': '提交',
  'pages.delete': '删除',
  'pages.another-action': '其他操作',
  'pages.actions': '操作',
  'pages.header': '标题',
  'pages.details': '详情',
  'pages.orders': '订单',
  'pages.rating': '评分',
  'pages.price': '价格',
  'pages.ingredients': '成分',
  'pages.is-vegan': '是否素食',
  'pages.order-status': '订单状态',
  'pages.bake-progress': '烘焙进度',
  'pages.popularity': '受欢迎程度',
  'pages.comments': '评论',
  'pages.error-title': '哎呀……似乎发生了错误！',
  'pages.error-code': '错误代码',
  'pages.go-back-home': '返回首页',
  'pages.mailing-info':
    '邮件模板使用内联样式和表格布局，以确保在各种服务提供商中良好显示。为了提供更好的可用性，我们将其作为普通HTML通过dangerouslySetInnerHTML包含。',
  'pages.invoice-info':
    '发票模板提供了适用于项目外使用的内联样式版本以及React版本。',
  'pages.react-version': 'React版本',
  'pages.inline-version': '内联样式HTML版本',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': '消息',
  'chat.contacts': '联系人',
  'chat.saysomething': '说点什么……',

  /* 06.02.Survey */
  'survey.delete': '删除',
  'survey.edit': '编辑',
  'survey.add-new': '新增',
  'survey.add-new-title': '添加新调查',
  'survey.title': '标题',
  'survey.category': '类别',
  'survey.label': '标签',
  'survey.status': '状态',
  'survey.cancel': '取消',
  'survey.submit': '提交',
  'survey.another-action': '其他操作',
  'survey.display-options': '显示选项',
  'survey.orderby': '排序方式：',
  'survey.all-surveys': '所有调查',
  'survey.completed-surveys': '已完成调查',
  'survey.categories': '类别',
  'survey.active-surveys': '进行中调查',
  'survey.labels': '标签',

  /* 06.03.Todo */
  'todo.add-new': '新增',
  'todo.add-new-title': '添加新待办事项',
  'todo.title': '标题',
  'todo.detail': '详情',
  'todo.category': '类别',
  'todo.label': '标签',
  'todo.status': '状态',
  'todo.cancel': '取消',
  'todo.submit': '提交',
  'todo.action': '操作',
  'todo.another-action': '其他操作',
  'todo.display-options': '显示选项',
  'todo.orderby': '排序方式：',
  'todo.all-tasks': '所有任务',
  'todo.pending-tasks': '待办任务',
  'todo.completed-tasks': '已完成任务',
  'todo.categories': '类别',
  'todo.labels': '标签',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': '圆角警告',
  'alert.react-notifications': 'React 通知',
  'alert.outline': '轮廓',
  'alert.primary': '主要',
  'alert.secondary': '次要',
  'alert.info': '信息',
  'alert.success': '成功',
  'alert.warning': '警告',
  'alert.error': '错误',
  'alert.filled': '填充',
  'alert.primary-text': '这是一个主要警告——请查看！',
  'alert.secondary-text': '这是一个次要警告——请查看！',
  'alert.success-text': '这是一个成功警告——请查看！',
  'alert.danger-text': '这是一个危险警告——请查看！',
  'alert.warning-text': '这是一个警告——请查看！',
  'alert.info-text': '这是一个信息警告——请查看！',
  'alert.light-text': '这是一个轻量警告——请查看！',
  'alert.dark-text': '这是一个深色警告——请查看！',
  'alert.default': '默认警告',
  'alert.dismissing': '可关闭警告',
  'alert.dismissing-text': '哇哦！你应该检查下面的一些字段。',
  'alert.dismissing-without-animate-text':
    '我是一个警告，我可以在不动画的情况下被关闭！',

  /* 07.02.Badges */
  'badge.sizes': '尺寸',
  'badge.colors': '颜色',
  'badge.outline': '轮廓',
  'badge.links': '链接',
  'badge.counter-badges': '计数徽章',
  'badge.bootstrap-default': 'Bootstrap 默认',
  'badge.primary': '主要',
  'badge.secondary': '次要',
  'badge.success': '成功',
  'badge.danger': '危险',
  'badge.warning': '警告',
  'badge.info': '信息',
  'badge.light': '浅色',
  'badge.dark': '深色',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap 默认',
  'button.colors': '颜色',
  'button.rounded': '圆角',
  'button.outline': '轮廓',
  'button.states': '状态',
  'button.sizes': '尺寸',
  'button.button-groups': '按钮组',
  'button.large-button': '大按钮',
  'button.small-button': '小按钮',
  'button.extra-small-button': '超小按钮',
  'button.block-button': '块级按钮',
  'button.active': '激活',
  'button.disabled': '禁用',
  'button.basic': '基础',
  'button.toolbar': '工具栏',
  'button.nesting': '嵌套',
  'button.vertical-variation': '垂直变体',
  'button.checkbox-radio-button': '复选框和单选按钮',
  'button.checkbox': '复选框',
  'button.radio': '单选',
  'button.radio-button': '单选按钮',
  'button.primary': '主要',
  'button.secondary': '次要',
  'button.success': '成功',
  'button.danger': '危险',
  'button.warning': '警告',
  'button.info': '信息',
  'button.light': '浅色',
  'button.dark': '深色',
  'button.states-text':
    '此按钮会显示2秒的加载动画，3秒的错误图标，然后恢复正常状态。该状态可通过添加和移除类触发。',
  'button.click-here': '点击这里',
  'button.states-text-alternate':
    '此按钮会显示2秒的加载动画，3秒的错误图标，然后恢复正常状态。该状态可通过添加和移除类触发。',
  'button.primary-link': '主要链接',
  'button.link': '链接',
  'button.primary-button': '主要按钮',
  'button.button': '按钮',
  'button.left': '左',
  'button.middle': '中',
  'button.right': '右',
  'button.dropdown': '下拉菜单',
  'button.dropdown-link': '下拉链接',

  /* 07.04.Cards */
  'cards.icon-card': '图标卡片',
  'cards.image-card': '图片卡片',
  'cards.image-overlay-card': '图片覆盖卡片',
  'cards.image-card-list': '图片卡片列表',
  'cards.tab-card': '标签卡片',
  'cards.user-card': '用户卡片',

  /* 07.05.Carousel */
  'carousel.basic': '基础轮播',
  'carousel.single': '单项轮播',
  'carousel.without-controls': '无控制轮播',

  /* 07.06.Charts */
  'charts.line': '折线图',
  'charts.polar': '极地图',
  'charts.area': '面积图',
  'charts.scatter': '散点图',
  'charts.bar': '柱状图',
  'charts.radar': '雷达图',
  'charts.pie': '饼图',
  'charts.doughnut': '环形图',
  'charts.shadow': '阴影',
  'charts.no-shadow': '无阴影',

  /* 07.07.Collapse */
  'collapse.basic': '基础',
  'collapse.toggle': '切换',
  'collapse.accordion': '手风琴',
  'collapse.controlled': '受控',
  'collapse.uncontrolled': '非受控',

  /* 07.08.Dropdowns */
  'dropdowns.basic': '基础',
  'dropdowns.controlled': '受控',
  'dropdowns.uncontrolled': '非受控',
  'dropdowns.dropdown': '下拉菜单',
  'dropdowns.header': '标题',
  'dropdowns.action': '操作',
  'dropdowns.another-action': '其他操作',
  'dropdowns.right': '右',
  'dropdowns.left': '左',
  'dropdowns.drop-directions': '下拉方向',
  'dropdowns.dropright': '向右下拉',
  'dropdowns.dropleft': '向左下拉',
  'dropdowns.small-button': '小按钮',
  'dropdowns.large-button': '大按钮',
  'dropdowns.sizing': '尺寸',
  'dropdowns.split-button': '拆分按钮下拉菜单',
  'dropdowns.dropup': '向上弹出',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill 标准',
  'editors.quill-bubble': 'Quill 气泡',

  /* 07.10.Forms */
  'forms.basic': '基础',
  'forms.email': '电子邮件',
  'forms.email-muted': '我们绝不会与任何人分享您的电子邮件。',
  'forms.password': '密码',
  'forms.submit': '提交',
  'forms.horizontal': '水平',
  'forms.radios': '单选按钮',
  'forms.first-radio': '第一个单选按钮',
  'forms.second-radio': '第二个单选按钮',
  'forms.third-radio-disabled': '第三个禁用单选按钮',
  'forms.checkbox': '复选框',
  'forms.signin': '登录',
  'forms.top-labels-over-line': '上方标签在线上方',
  'forms.tags': '标签',
  'forms.date': '日期',
  'forms.state': '州/省',
  'forms.top-labels-in-input': '输入框内上方标签',
  'forms.email-u': '电子邮件',
  'forms.password-u': '密码',
  'forms.tags-u': '标签',
  'forms.date-u': '日期',
  'forms.state-u': '州/省',
  'forms.grid': '表单网格',
  'forms.address': '地址',
  'forms.address2': '地址 2',
  'forms.city': '城市',
  'forms.city-message': '请选择一个城市！',
  'forms.state-message': '请选择一个州/省！',
  'forms.zip': '邮编',
  'forms.signup': '注册',
  'forms.inline': '内联',
  'forms.validation-availity': 'Availity Reactstrap 验证',
  'forms.validation-formik': 'Formik 验证',
  'forms.default': '默认',
  'forms.firstname': '名',
  'forms.firstname-message': '请输入您的名字！',
  'forms.lastname': '姓',
  'forms.lastname-message': '请输入您的姓！',

  /* 07.11.Form Components */
  'form-components.custom-inputs': '自定义输入',
  'form-components.checkboxes': '复选框',
  'form-components.radios': '单选按钮',
  'form-components.inline': '内联',
  'form-components.react-select': 'React 选择',
  'form-components.state-single': '单一州/省',
  'form-components.state-multiple': '多个州/省',
  'form-components.react-autosuggest': 'React 自动建议',
  'form-components.date-picker': '日期选择器',
  'form-components.date': '日期',
  'form-components.date-range': '日期范围',
  'form-components.date-with-time': '带时间的日期',
  'form-components.embedded': '嵌入式',
  'form-components.dropzone': '文件拖放区',
  'form-components.drop-files-here': '将文件拖到这里',
  'form-components.tags': '标签',
  'form-components.switch': '开关',
  'form-components.primary': '主要',
  'form-components.secondary': '次要',
  'form-components.primary-inverse': '主要反色',
  'form-components.secondary-inverse': '次要反色',
  'form-components.slider': '滑块',
  'form-components.double-slider': '双滑块',
  'form-components.single-slider': '单滑块',
  'form-components.rating': '评分',
  'form-components.interactive': '交互式',
  'form-components.readonly': '只读',
  'form-components.type-a-cake': '输入蛋糕',
  'form-components.start': '开始',
  'form-components.end': '结束',
  'form-components.tables': '表格',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line 图标',
  'icons.iconsmind': 'Iconsmind 图标',

  /* 07.13.Input Groups */
  'input-groups.basic': '基础',
  'input-groups.sizing': '大小',
  'input-groups.small': '小',
  'input-groups.default': '默认',
  'input-groups.large': '大',
  'input-groups.checkboxes-and-radios': '复选框和单选按钮',
  'input-groups.multiple-inputs': '多输入',
  'input-groups.first-and-last-name': '名字和姓氏',
  'input-groups.multiple-addons': '多附加项',
  'input-groups.button-addons': '按钮附加项',
  'input-groups.button': '按钮',
  'input-groups.buttons-with-dropdowns': '带下拉菜单的按钮',
  'input-groups.dropdown': '下拉菜单',
  'input-groups.header': '标题',
  'input-groups.action': '操作',
  'input-groups.another-action': '另一个操作',
  'input-groups.custom-select': '自定义选择',
  'input-groups.options': '选项',
  'input-groups.choose': '请选择...',
  'input-groups.custom-file-input': '自定义文件输入',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': '你好，世界！',
  'jumbotron.lead':
    '这是一个简单的主角单元，是一个简单的 jumbotron 风格组件，用于吸引对特色内容或信息的额外关注。',
  'jumbotron.lead-detail': '它使用排版和间距的实用类来在更大的容器中分隔内容。',
  'jumbotron.learn-more': '了解更多',

  /* 07.15.Modal */
  'modal.basic': '基础',
  'modal.modal-title': '模态框标题',
  'modal.launch-demo-modal': '启动演示模态框',
  'modal.scrolling-long-content': '滚动长内容',
  'modal.backdrop': '背景幕',
  'modal.backdrop-value': '背景幕值',
  'modal.right-modal': '右侧模态框',
  'modal.launch-right-modal': '启动右侧模态框',
  'modal.nested-modal': '嵌套模态框',
  'modal.size': '大小',
  'modal.launch-large-modal': '启动大模态框',
  'modal.launch-small-modal': '启动小模态框',

  /* 07.16.Navigation */
  'nav.basic': '基础导航',
  'nav.active': '激活',
  'nav.disabled': '禁用',
  'nav.disabled-link': '禁用链接',
  'nav.link': '链接',
  'nav.longer-link': '较长的导航链接',
  'nav.another-link': '另一个链接',
  'nav.right': '右侧',
  'nav.dropdown': '下拉菜单',
  'nav.header': '标题',
  'nav.action': '操作',
  'nav.another-action': '另一个操作',
  'nav.horizontal-alignment': '导航水平对齐',
  'nav.vertical-alignment': '导航垂直对齐',
  'nav.pills': '导航标签',
  'nav.fill-justify': '导航填充和对齐',
  'nav.pills-dropdowns': '带下拉菜单的导航标签',
  'nav.pagination-basic': '基础分页',
  'nav.pagination-sizing': '分页大小',
  'nav.large': '大',
  'nav.small': '小',
  'nav.center': '居中',
  'nav.pagination-alignment': '分页对齐',
  'nav.breadcrumb-basic': '基础面包屑',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': '弹出框',
  'popover-tooltip.tooltip': '工具提示',

  /* 07.18.Sortable */
  'sortable.columns': '排序列',
  'sortable.basic': '基础',
  'sortable.handles': '拖动手柄',

  /* 07.19.Maps */
  'maps.google': '谷歌',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap 表格',
  'table.bootstrap-basic': '基础表格',
  'table.bootstrap-striped': '条纹行',
  'table.bootstrap-bordered': '带边框表格',
  'table.bootstrap-borderless': '无边框表格',
  'table.bootstrap-hoverable': '悬停行',
  'table.bootstrap-responsive': '响应式表格',
  'table.react-tables': 'React 表格',
  'table.react-pagination': '分页',
  'table.react-scrollable': '可滚动',
  'table.react-advanced': '过滤，长度和跳转',

  /* Property Info */
  'property-info.allcustomers': '所有客户',
  'property-info.external-sources': '外部来源',
  'property-info.faq': '常见问题',
  'property-info.documents': '文件',
  'property-info.publish-ai': '发布 AI',
  'property-info.pre-built-templates': '预构建模板',
  'property-info.room-types': '房型',
  'property-info.about-property': '关于物业',
  'property-info.about-properties': '关于属性',
  'property-info.facilities-services': '设施与服务',
  'property-info.property-facilities': '物业设施',
  'property-info.room-amenities': '客房设施',
  'property-info.property-contact': '物业联络人',
  'property-info.property-activities': '物业活动',
  'property-info.property-location': '物业位置',
  'property-info.about-rooms': '关于客房',
  'property-info.about-sites': '关于网站',
  'property-info.special-emergencies': '紧急情况',
  'property-info.gallery': '画廊',
  'property-info.policies': '政策规定',
  'property-info.nearby': '附近',
  'property-info.transport': '运输',
  'property-info.location': '地点',
  'property-info.about-rhproperty': '关于退休之家',
  'property-info.related-topics': '相关话题',
  'property-info.assistant-options': '助理选项',
  'property-info.restaurant-assistant-information': '餐厅信息',
  'property-info.restaurant-assistant-options': '欢迎辞',
  'property-info.channel-messages': '频道消息',
  'property-info.icon.gallery': '图标库',
  'property-info.copilot': '副驾驶',
  'property-info.sprint': '短跑',
  'property-info.home-information': '首页信息',
  'property-info.loction': '地点',
  'property-info.rooms-and-images': '房间和图片',
  'property-info.trainig-data': '训练数据',
  'property-info.flows': '流量',
  'property-info.add-your-own': '添加您自己的',
  'property-info-utility-miscellaneous': '各种各样的',
  'property-info-utility-payment': '付款方式',
  'property-info-utility-broadband': '宽带',
  'property-info-utility-emergency': '紧急情况',
  'property-info-utility-mobile': '移动的',
  'property-info-utility-moving': '移动',
  'property-info.publishMonitor': '发布与监控',
  'property-info.webWidget': '网页小部件',
  'property-info.media': '媒体',
  /** Rate & Promo */
  'rate-promo.rate-plans': '收费计划',
  'rate-promo.rate-plan-addons': '附加组件',
  'rate-promo.rate-plan-promos': '宣传片',

  'title.property-information': '物业资讯',

  'property.message': '信息',
  'property.example': '例子',
  'property.link': '链接',
  'property.image-carousel': '图像轮播',
  'property.Title': '标题',
  'property.SubTitle': '副标题',

  'property.add-invoke-api': '调用API',
  'property.add-message-button': '新增讯息',
  'property.add-img-button': '新增图片',
  'property.add-link-button': '添加链接',
  'property.add-herocard-button': '添加英雄卡',
  'property.add-api-button': '添加按钮',

  'menu.settings': '设置',
  'menu.workflows': '工作流',
  'menu.product_services': '产品与服务',
  'menu.product_recommander': '产品推荐器',
  'menu.digital_guide_book': '数字指南书',
  'menu.welcome_message': '欢迎消息',

  'menu.about-property': '关于物业',
  'menu.property-facilities': '物业设施',
  'menu.room-amenities': '客房设施',
  'menu.property-contact': '物业联络人',
  'menu.about-rooms': '关于客房',
  'menu.special-emergencies': '紧急情况',
  'menu.show-filter': '过滤器',
  'menu.new': '新的',
  'menu.channel': '渠道',
  'menu.application': '应用程序',
  'menu.content-manager': '内容管理器',
  'menu.events-calendar': '事件日历',
  'menu.appearance-settings': '外观与设置',
  'menu.help': '帮助',
  'menu.myAccounts': '我的账户',

  'dashboards.send': '发送',
  'dashboards.hello': '你好',
  'dashboards.notificationsAllowed': '允许通知',
  'dashboards.allowNotifications': '允许通知',
  'dashboards.views': '浏览量',
  'dashboards.bookingURL': '预订网址',
  'dashboards.searchTags': '搜索标签',
  'dashboards.searchCategoryTags': '搜索类别标签',
  'dashboards.bedroom': '卧室',
  'dashboards.addBedroom': '添加卧室',
  'dashboards.frequency': '频率',
  'dashboards.includeSubpages': '包括子页面',
  'dashboards.enableFaqs': '启用常见问题',
  'dashboards.faqsDescription':
    '启用常见问题后，您可以输入问题，系统会从网页内容中提取相应的回答以创建完整的常见问题',
  'dashboards.faq': '常见问题',
  'dashboards.deleteDocument': '删除文档',
  'dashboards.confirmDelete': '您确定要删除吗？',
  'dashboards.addItem': '添加项目',
  'dashboards.addFirstWebPage': '添加您的第一个网页',

  'dashboards.popular-compendium': '热门汇编菜单项',
  'dashboards.wordcloudofcompendium': '汇编菜单项的词云',
  'dashboards.wordcloudonthings': '	网站访客提问及菜单项的词云',
  'dashboards.common-asked': '常见问题',
  'dashboards.website-visitor-asking': '网站访问者在问的事情',
  'dashboards.visit-country': '网站访问国家（地区）',
  'dashboards.visit-traffic': '网站流量的国家',
  'dashboards.rooms-product': '房间和产品',
  'dashboards.popular-room-product': '受欢迎的房间和产品',

  'dashboards.messenger-stats': '人气菜品',
  'dashboards.messenger-stats-topic-view': '菜单项视图的统计信息',
  'dashboards.messenger-stats-visits': '菜单项视图',
  'dashboards.opening-menu-items': '打开菜单项的网站访问者数量',

  'dashboards.number-totalavatarclick': '头像总点击次数',
  'dashboards.tickets-by-category': '按类别划分的票证',
  'dashboards.download': '下载',
  'dashboards.clicks': '点击次数',
  'dashboards.leads': '线索',
  'dashboards.hours': '小时',
  'dashboards.minutes': '分钟',
  'dashboards.subscribe-to-reports': '订阅报告',
  'dashboards.ai-chatbot': '人工智能聊天机器人',
  'dashboards.compendium': '概要',
  'dashboards.compendium-digital-usage': '数字纲要的使用',
  'dashboards.compendium-unique-visits': '二维码扫描/点击',
  'dashboards.compendium-opening-menu-items': '查看的菜单项数',
  'dashboards.compendium-total-digital-clicks': '菜单项总浏览量',
  'dashboards.compendium-total-qr-code': '二维码扫描/点击总数',
  'dashboards.compendium-avg-menu-items': '每次扫描的平均菜单项浏览量',
  'dashboards.top-clicked-urls': '点击次数最多的URL',
  'dashboards.top-clicked-urls-description': 'URL点击分析',
  'dashboards.urls': 'URL',
  'dashboards.externalDeleteMessage':
    '此文档是从外部来源生成的。如果您不希望再次创建它，请确保同时删除相关的同步计划。',
  'dashboards.deleteAndGoToExternalSources': '删除并前往外部来源',
  'property.delete': '删除',
  'menu.userroles': '用户和角色',
  'menu.members': '会员',
  'menu.guest-pass': '来宾通行证',
  'menu.ratebookings': '房价和预订',
  'dashboards.engagement-time': '数字助理参与时间',
  'dashboards.conversations-minutes':
    '总分钟数和过夜（晚上 7 点至早上 7 点）对话分钟数',
  'dashboards.visitor-questions': '访客问题',
  'dashboards.recent-queries': '最近查询',
  'dashboards.visitor-saying': '您的访客对数字助理说的是什么',
  'dashboards.contacts-prechatform-leavemessage':
    '聊天前表格和留言中存储的联系人',
  'menu.dashboards': '见解',
  'menu.ari': '可用性和价格',
  'menu.conversations': '对话内容',
  'menu.conversations.unified-inbox': '统一收件箱',
  'menu.conversations.active': '活跃聊天',
  'menu.conversations.archives': '档案',
  'menu.conversations.missed-responses': '错过回复',
  'menu.conversations.ticket': '门票',
  'menu.conversations.reply-templates': '回复模板',
  'menu.bookings': '预订与订座',
  'menu.tickets': '潜在客户与门票',
  'menu.propinfo': '知识中心',
  'menu.rate-promos': '利率与促销',
  'menu.finance': '金融',
  'menu.integration': '连接',
  'menu.admin': '管理员与安全性',
  'menu.favourites': '收藏夹',
  'menu.recommender': '对话流程',
  'menu.assistant-setup': '助理设置',
  'menu.admin-insights': '管理洞察',
  'menu.super-admin': '超级管理员',
  'menu.groups': '团体',
  'menu.properties': '特性',
  'menu.service-provider': '服务提供商',
  'menu.spaces': '空间',
  'menu.availability': '可用性',
  'menu.guest-messaging': '客人消息',
  'dashboards.space-booking': '舱位预订',
  'dashboards.gift-voucher': '礼券',
  'dashboards.chatbots': '聊天机器人',
  'dashboards.form': '从',
  'dashboards.to': '到',
  'dashboards.active-groups': '活跃团体',
  'dashboards.active-properties': '活跃属性',
  'dashboards.live-properties': '实时属性',
  'dashboards.properties-going': '按日期范围上线的属性',
  'dashboards.start-date': '开始日期',
  'dashboards.end-date': '结束日期',

  'dashboards.website-visits': '网站访问',
  'dashboards.unique-visitors': '不重复访客',
  'dashboards.last-week': '上个星期',
  'dashboards.this-week': '本星期',
  'dashboards.this-month': '这个月',
  'dashboards.previous-month': '前一个月',
  'dashboards.yeartodate': '今年迄今为止',
  'dashboards.lastyear': '去年',
  'dashboards.last-7-days': '最近7天',
  'dashboards.last-30-days': '最近30天',
  'dashboards.last-60-days': '最近60天',
  'dashboards.last-90-days': '最近90天',
  'dashboards.conversion-rates': '转换率',
  'dashboards.digital-assistant-engagement': '数字助理互动',
  'dashboards.total-overnight-conversations':
    '总计和过夜（晚上 7 点至早上 7 点）对话',
  'dashboards.percentage-accuracy': '知识覆盖范围',
  'dashboards.percentage-conversion': '网站流量到聊天的转化',
  'dashboards.percentage-avatarclick': '网站流量与头像点击量',
  'dashboards.percentage-negativefeedback': '负面反馈占头像点击的百分比',
  'dashboards.percentage-amenties': '便利设施查询',
  'dashboards.percentage-booking': '订票查询',
  'dashboards.percentage-webchats': '网站聊天',
  'dashboards.percentage-facebookchat': 'Facebook聊天',
  //'dashboards.number-webchattime': '网络聊天总时间',
  'dashboards.number-averagetimeconversation': '每次对话平均时间',

  'dashboards.number-webchattime': '总对话时间',
  'dashboards.number-totalconversation': '总对话',
  'dashboards.number-websiteconversation': '网站对话',
  'dashboards.number-facebookconversation': '脸书对话',
  'dashboards.number-estimatedtimesaving': '预计节省时间',
  'dashboards.number-googlemapsconversation': '谷歌地图对话',
  'dashboards.number-whatsappconversation': 'WhatsApp 对话',
  'dashboards.number-instagramconversation': 'Instagram 对话',
  'dashboards.number-agentconversation': '代理对话',
  'dashboards.number-amenityqueries': '便利设施查询',
  'dashboards.number-bookingenquiries': '预订查询',
  'dashboards.number-groupbookingenquiries': '团体预订查询',
  'dashboards.number-eventenquiries': '活动查询',
  'dashboards.number-longstayenquiries': '长住查询',
  'dashboards.number-totaltickets': '门票',
  'dashboards.number-returncustomer': '回头客',
  'dashboards.number-redirects': '网站重定向',
  'dashboards.number-bookingengineleads': '预订引擎线索',
  'dashboards.number-roomnightsreferred': '推荐的房晚',
  'dashboards.number-revenuereferred': '收入推荐',
  'menu.bookingsmenu': '订票',
  'menu.guests': '宾客信息',
  'menu.whatsnew': '什么是新的',

  'forms.forms-title': '形式',
  'menu.formbuilder': '表单生成器',
  'dashboards.trainAI': '用文档训练 AI',
  'dashboards.uploadDocuments':
    '上传文档以帮助您的 AI 了解您的业务并像您一样协助客户。您可以添加 .doc、.pdf 或 .txt 格式的文件。',
  'menu.virtualfrontdesk': '虚拟前台',
  'menu.guestservice': '客户服务',
  'virtual-front.common-questions': '常见问题',
  'virtual-front.add-on-upsells': '附加组件和追加销售',
  'virtual-front.service-order': '服务订单',
  //'virtual-front.guest-service-add-on-upsells': "宾客服务和附加服务",
  'virtual-front.guest-service-add-on-upsells': '数字留言簿',
  'virtual-front.outbound': '出站',
  'virtual-messenger': '信使',
  'dashboards.welcomeMessage': '欢迎信息',
  'dashboards.personalizeGreeting':
    '个性化客户的问候方式，使其体现您的品牌、风格和礼仪，确保客户获得最热情的欢迎。自定义问候语以展现品牌，营造温馨氛围。',
  'missed-response.missed-response-title': '错过回复标题',
  'dashboards.addRoomDetails':
    '添加有关每个房间的详细信息，以便客人可以轻松发现他们需要的一切，从而选择最合适的房型，并使预订流程更简单、更快速。',
  'dashboards.trainAIFAQs': '用常见问题训练 AI',
  'dashboards.manualQuestions':
    '有些问题无法通过文档回答或在网站上找到。在这里，您可以手动添加问题，以确保客户始终可以获得他们需要的信息。',
  'dashboards.publishAI': '发布 AI 以反映最新更新',
  'dashboards.retrainAfterChanges':
    '当您在知识中心或表单中进行更改时，请务必使用更新后的信息重新训练聊天机器人。发布您的 AI 可确保聊天机器人提供最准确、最新的答案。',
  'dashboards.enhanceKnowledge': '通过跟踪未回答的查询增强 AI 知识',
  'dashboards.reviewUnanswered':
    '每当 AI 无法回答问题或仅提供有限细节时，您会在此处找到这些查询。检查它们以识别您 Knowledge Hub 中的空白或客人独特的问题。',
  'dashboards.manageMedia': '管理媒体',
  'dashboards.mediaGallery':
    '每当您上传房间、设施、标识或您的数字头像等图像时，它们将显示在此图库中，为您提供一个集中管理视觉资源的地方，并确保您的客人看到使您的业务独特的部分。',
  'dashboards.createForms': '轻松创建表单，并在每次提交时收到通知。',
  'dashboards.manageForms':
    '创建并管理表单以收集客户信息、设置通知，并为不同语言自定义。',
  'dashboards.personalizeResponse': '个性化响应风格和对话进展方式',
  'dashboards.controlConversation':
    '此高级功能使您能够塑造并控制与客户在不同渠道上的对话展开方式。',

  'content.allconversation': '所有对话',
  'content.active': '活跃',
  'content.tickets': '工单',
  'content.filter': '筛选',
  'content.createtickets': '创建工单',
  'content.conversation': '对话',
  'content.knowledgesearch': '知识搜索',
  'content.reply': '回复',
  'content.visitorinfo': '访客信息',
  'content.callinfo': '通话信息',
  'content.allinsights': '所有洞察',
  'content.availabilityrates': '可用性及费率',
  'content.callback': '回拨',
  'content.close': '关闭',
  'content.sms': '短信',
  'content.timestamp': '时间戳记',
  'content.topics': '主题',
  'content.callingparty': '来电方',
  'content.accountdomain': '账户域',
  'content.calledparty': '被叫方',
  'content.recording': '录音',
  'content.phonesystemoriginationcallid': '电话系统起始通话ID',
  'content.phonesystemterminationcallid': '电话系统结束通话ID',
  'content.uniqueconversationid': '唯一对话ID',
  'content.regenerateinsights': '重新生成洞察',
  'content.customersentiment': '客户情绪',
  'content.neutral': '中立',
  'content.customerreportedbroadbandoutage':
    '客户报告宽带故障，并提供其客户ID及服务激活日期以寻求帮助。',
  'content.conversationinsights': '对话洞察',
  'content.broadbandoutage': '宽带故障',
  'content.customeridverification': '客户ID验证',
  'content.serviceactivationdate': '服务激活日期',
  'content.followups': '后续跟进',
  'content.actionneeded': '需要采取行动',
  'content.uniqueConversationId': '唯一会话ID',
  'content.uniqueChatId': '唯一聊天ID',
  'content.recording&transcript': '录音与文字记录',
  'content.chatinsights': '聊天洞察',
  'content.visitedpages': '访问的页面',
  'content.deviceinfo': '设备信息',
  'content.chatstartedonthispage': '聊天在此页面开始',
  'content.prechatinfo': '聊天前信息',
  'content.notes': '笔记',
  'content.reassign': '重新分配',
  'content.open': '打开',
  'content.dismiss': '关闭',
  'content.add_placeholder': '添加占位符值',
  'content.mobile_number': '手机号',
  'content.please_select': '请选择',
  'content.sendwhatsapp': '发送 WhatsApp 消息',

  /* Missed Response */
  'feedback.missed-question': '未回答的问题',
  'feedback.conversation-summary': '对话摘要',
  'feedback.dates-in-spanish': '日期需要是西班牙语',
  'feedback.resolve': '解决',
  'feedback.ignore': '忽略',

  //integration
  // zh-ZH
  'integration.select_properties': '选择属性',
  'integration.select_properties_enabled': '选择通过此集成启用的属性',
  'integration.services_addons': '选择服务和插件',
  'integration.services_visible': '选择哪些服务和插件将在此页面中可见',
  'integration.appearance': '外观',
  'integration.appearance_customize': '选择您的数字助理名称、头像并设置颜色',
  'integration.booking_calendar': '预订日历',
  'integration.booking_calendar_style': '选择预订日历弹出窗口的样式',
  'integration.nudges': '提示',
  'integration.nudges_setup': '设置主动消息以吸引网站访问者',
  'integration.position': '位置',
  'integration.position_control': '控制聊天小部件在您网站上的位置',
  'integration.custom_fonts': '自定义字体',
  'integration.custom_fonts_upload': '上传您想在页面上使用的任何自定义字体',
  'integration.custom_css': '自定义 CSS',
  'integration.custom_css_usage': '使用 CSS 定制您的数字简介',
  'integration.location': '位置',
  'integration.location_embed': '添加您的嵌入位置 URL',
  'integration.external_links': '外部链接',
  'integration.external_links_add': '添加您的链接',
  'integration.language': '语言',
  'integration.widget_languages': '选择聊天小部件的语言',
  'integration.chatbot_contact': '聊天机器人',
  'integration.chatbot_enable': '启用您的数字助理',
  'integration.chatbot_security': '保持 Messenger 安全',
  'integration.chatbot_trusted_pages': '列出可信页面以显示聊天机器人',
  'integration.chatbot_publish': '发布您的数字助理',
  'integration.chatbot_install': '复制代码片段以安装您的数字助理',
  'integration.google_analytics': 'Google Analytics 跟踪',
  'integration.google_analytics_desc':
    '使用 GA4 跟踪 Web Widget 中的用户活动、会话和关键操作。',
  'integration.enable_ga4': '启用 Google Analytics',
  'integration.ga4_measurement_id': 'GA4 衡量 ID',
  'integration.ga4_id_example': '示例：G-ABCD123456',
  'integration.track_events': '跟踪事件',
  'integration.track_events_desc': '选择要作为 GA4 事件发送的用户操作。',
  'integration.avatar_click': '头像点击',
  'integration.avatar_click_desc': '在用户点击聊天头像时进行跟踪。',
  'integration.nudge_click': '提示点击',
  'integration.menu_click': '菜单点击',
  'integration.menu_click_desc': '在用户打开 Web Widget 菜单时进行跟踪。',
  'integration.chat_started': '聊天开始',
  'integration.chat_started_desc': '每个会话仅跟踪一次用户的第一条消息。',
  'integration.event_tag': '事件标签',
  'integration.event_prefix': '事件前缀',
  'integration.final_tag': '最终标签',
  'integration.example_event': '事件示例',
  'integration.once_per_session': '每个会话仅一次',
  'integration.saving': '保存中...',
  'integration.save_ga4_settings': '保存 GA4 设置',

  'guest-messaging.settings': '设置',
  'guest-messaging.outreach-setup': '外展设置',
  'guest-messaging.reservations': '预订',
  'guest-messaging.insights_logs': '洞察与日志',
  'guest-messaging.placeholder': '客人消息模块即将上线。',
  'guest-messaging.settings.placeholder': '配置客人消息偏好。',
  'guest-messaging.outreach.placeholder': '设置外展活动和模板。',
  'guest-messaging.reservations.placeholder': '管理与预订相关的消息。',
  'guest-messaging.reservation-source': '预订数据来源',
  'guest-messaging.communication-channels': '沟通渠道',
  'guest-messaging.templates': '模板',
  'guest-messaging.link': '链接',
  'guest-messaging.business-profile': '企业简介',
};
export default chMessages;
